module.exports = __webpack_public_path__ + "img/mark3.ebbd4fbf.png";